import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  DoCheck,
  ViewEncapsulation,
  ViewChild
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResetState } from '@app/core/user/store/actions/user.actions';
import { IAppState } from '@app/store';
import { Store } from '@ngrx/store';
import { UserService } from '@app/core/user/services/user/user.service';
import { PrivacyPolicyService } from '@app/core/privacy-policy/services/privacy-policy.service';
import { PopoverDirective } from '@app/shared/directives/popover/popover.directive';
import { BREAKPOINTS } from '@app/store/reducers/device.reducer';

@Component({
  selector: 'vc-auth-modal',
  templateUrl: './auth-modal.component.html',
  styleUrls: ['./auth-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class AuthModalComponent implements OnInit, DoCheck {
  resetPassword: false;
  email: string;
  type: 'login' | 'register' | 'login-register' = 'login';
  popinForced: boolean;

  @ViewChild(PopoverDirective, { static: false })
  public popoverDirective: PopoverDirective;

  constructor(
    private store: Store<IAppState>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private privacyPolicyService: PrivacyPolicyService,
    private userService: UserService
  ) {
    if (this.data.type === 'register') {
      this.type = 'register';
    }

    this.popinForced = this.data.forced;
  }

  ngOnInit() {
    // this.store.dispatch(new ResetState());

    if (this.privacyPolicyService.hasDefaultSettings()) {
      this.privacyPolicyService.setDefaultAcceptance();
    }

    this.userService.getAuthDialogData().subscribe(
      res => {
        if (res) {
          this.email = res.credentials.email;

          if (res.authModalType === 'register') {
            this.type = 'register';
          }
        }
      },
      err => {}
    );

    if (window && window.innerWidth < BREAKPOINTS.medium) {
      this.type = window.innerWidth < BREAKPOINTS.medium ? 'login-register' : this.data.type;
    }
  }

  ngDoCheck() {
    // Subscribe to event to force re-render component and it's children
    // Attention, only usefull if changeDetection === ChangeDetectionStrategy.OnPush
    if (this.popoverDirective) {
      this.popoverDirective.onHidden.subscribe(
        () => {
          this.cdr.markForCheck();
        },
        error => {}
      );
    }
  }

  displayResetPassword(value) {
    this.resetPassword = value;
  }

  displayComponent(name: 'login' | 'register'): void {
    this.store.dispatch(new ResetState());
    this.type = name;
  }

  setCurrentEmail(value) {
    this.email = value;
  }
}
